import type { Icon, IconProps } from "iconsax-reactjs";
import * as Iconsax from "iconsax-reactjs";
import { cn } from "../../utils/cn";

type DSIconName = keyof typeof Iconsax;
type DSIconLibraryProps = IconProps;

type DSIconProps = {
  className?: string;
  name: DSIconName;
} & DSIconLibraryProps;

function DSIcon({ className, name, ...props }: DSIconProps) {
  const IconComponent = Iconsax[name] as Icon;
  return <IconComponent className={cn(className)} {...props} />;
}

export { DSIcon };
export type { DSIconLibraryProps, DSIconName, DSIconProps };
